module.exports = __webpack_public_path__ + "img/big-play.0607c33e.png";